import IndigoServiceClient from 'communication/IndigoServiceClient';
import { IndexEventsRequest } from './IndexEventsRequest';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { IndexEventsResponse } from './IndexEventsResponse';

export async function callIndexEventsApi(
    indigoServiceClient: IndigoServiceClient,
    request: IndexEventsRequest,
    options: ApiRequestOptions
) {
    const { symbols, symbology, side, tradeCategories } = request;

    const formData = new FormData();
    formData.append('symbols', symbols);
    formData.append('symbology', symbology);
    if (side) {
        formData.append('side', side);
    }
    if (tradeCategories) {
        formData.append('tradeCategories', tradeCategories);
    }

    const url = 'indexRebal/search';

    return await IndigoApiError.runHandlingErrorsAsync(
        `Index Rebalance Search`,
        async () => {
            return await indigoServiceClient.postFormData<IndexEventsResponse>(
                url,
                formData,
                options
            );
        }
    );
}
